/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ActivityTypeFilterEnum = {
    Web: 'WEB',
    App: 'APP'
} as const;
export type ActivityTypeFilterEnum = typeof ActivityTypeFilterEnum[keyof typeof ActivityTypeFilterEnum];
